export default __webpack_public_path__ + "static/media/facebook_icon.23abf5b7.webp";